import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getSimplifiedError } from "../../utils";
import { ApiService, url } from "../../utils/endpoints";
import { handleRejected, startLoading } from "../Authentication/authSlice";
import { toast } from "sonner";

const block = {
  loading: false,
  success: false,
  error: { status: null, message: "" },
  data: {},
};

const initialState = {
  ...block,
  updateSettingsState: { ...block },
};

const handleFulfilled = (
  state: any,
  initialStateKey: string,
  { payload }: { payload: any }
) => {
  if (initialStateKey === null) {
    state.loading = false;
    state.success = true;
    state.data = payload?.data;
  } else if (state.hasOwnProperty(initialStateKey)) {
    state[initialStateKey].loading = false;
    state[initialStateKey].success = true;
    state[initialStateKey].data = {
      ...payload.data,
    };
  }
};

export const updateUserSettings = createAsyncThunk(
  "updateUserSettings",
  async (payload: any, { rejectWithValue, getState }) => {
    try {
      const user: any = getState();
      const { data } = await ApiService.put(url.account_setup, payload, {
        headers: { Authorization: `Bearer ${user?.user?.token}` },
      });
      toast.success("Your settings updated successfully");
      return data;
    } catch (error: any) {
      return rejectWithValue(getSimplifiedError(error));
    }
  }
);



export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    clearState: (state) => {
      Object.assign(state, initialState);
    },
    resetBlockAuth(state, action: PayloadAction<{ blockType: any }>) {
      return action.payload.blockType === null
        ? { ...state, loading: false, success: false }
        : {
            ...state,
            [action.payload.blockType]: {
              ...initialState[action.payload.blockType],
            },
          };
    },
    resetFlag(state, action: PayloadAction<{ blockType: string }>) {
      const { blockType } = action.payload;
      const initialStateForKey = initialState[blockType];
      if (blockType === null) {
        return {
          ...initialState,
          data: state.data,
        };
      }
      return {
        ...state,
        [blockType]: {
          ...state[blockType],
          loading: initialStateForKey.loading,
          success: initialStateForKey.success,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserSettings.pending, (state, action) => {
        startLoading(state, "updateSettingsState", {
          loading: true,
          success: false,
        });
      })
      .addCase(updateUserSettings.fulfilled, (state, action) => {
        handleFulfilled(state, "updateSettingsState", action);
      })
      .addCase(updateUserSettings.rejected, (state, action) => {
        handleRejected(state, "updateSettingsState", action);
      })
  },
});

export const settingsSelector = (state: any) => state.settings;
export const { clearState, resetBlockAuth, resetFlag } = settingsSlice.actions;

export default settingsSlice.reducer;
